import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Switch, message } from "antd";
import { NotifyGroupAPI } from "../../constants/GenericAPI";

export const GroupSettingModal = ({ visible, onCancel, onSubmit, filterOptions, targetGroupOptions, selectedGroup }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (selectedGroup) {
        form.setFieldsValue({
          ...selectedGroup,
          is_active: selectedGroup?.is_active === 1,
          send_all_to_customer: selectedGroup?.send_all_to_customer === 1,
        });
      } else {
        // 新增模式
        form.setFieldsValue({
          group_name: "",
          main_identifier: "",
          filter_id: 0,
          tg_option_id: 0,
          gap_time: 15,
          is_active: true, // 新增時預設為啟用
          send_all_to_customer: false,
        });
      }
    }
  }, [visible, selectedGroup, form]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        const normalizedKeywords = Array.isArray(values.keywords)
          ? values.keywords.map((k) => (typeof k === "string" ? k.trim() : k)).filter((k) => k)
          : typeof values.keywords === "string"
          ? values.keywords
              .split(/[\s,，;；]+/)
              .map((k) => k.trim())
              .filter((k) => k)
          : [];

        const formData = {
          ...values,
          keywords: normalizedKeywords,
          is_active: values.is_active ? 1 : 0,
          send_all_to_customer: values.send_all_to_customer ? 1 : 0,
        };
        try {
          console.log(selectedGroup);
          // console.log(formData);
          if (selectedGroup) {
            formData.id = selectedGroup.id;
            await NotifyGroupAPI.update(selectedGroup.id, formData);
            message.success("群組設定修改成功");
          } else {
            const response = await NotifyGroupAPI.create(formData);
            // console.log(response.data);
            formData.id = response.data.data.id;
            message.success("群組設定新增成功");
          }
          // console.log(formData);
          onSubmit(formData);
          onCancel();
        } catch (error) {
          console.error("提交失敗:", error);
          message.error("操作失敗，請稍後再試");
        }
      })
      .catch((info) => {
        console.log("驗證填入資料失敗:", info);
        message.error("請檢查填入資料");
      });
  };

  return (
    <Modal
      title={`${selectedGroup ? "修改" : "新增"}通知群組${selectedGroup ? ` - ${selectedGroup.group_name}` : ""}`}
      open={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      okText="確認"
      cancelText="取消"
      afterClose={() => form.resetFields()}
      okButtonProps={{
        type: "primary",
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="group_name" label="群組名稱" rules={[{ required: true, message: "請輸入群組名稱" }]}>
          <Input placeholder="請輸入群組名稱" />
        </Form.Item>

        <Form.Item name="main_identifier" label="郵件識別碼" rules={[{ required: true, message: "請輸入郵件識別碼" }]}>
          <Input placeholder="請輸入郵件識別碼" />
        </Form.Item>

        <Form.Item name="gap_time" label="發報間隔(min)" rules={[{ required: true, message: "請輸入發報間隔" }]}>
          <Input placeholder="請輸入發報間隔（分鐘）" />
        </Form.Item>

        <Form.Item name="filter_id" label="篩選器">
          <Select
            placeholder="請選擇篩選器"
            options={filterOptions.map((option) => ({
              value: option.id,
              label: option.name,
              disabled: option.is_active === 0,
            }))}
          />
        </Form.Item>

        <Form.Item name="tg_option_id" label="目的群">
          <Select
            placeholder="請選擇目的群"
            options={targetGroupOptions.map((option) => ({
              value: option.id,
              label: option.name,
              disabled: option.is_active === 0,
            }))}
          />
        </Form.Item>

        <Form.Item name="is_active" label="狀態" valuePropName="checked">
          <Switch checkedChildren="啟用" unCheckedChildren="停用" />
        </Form.Item>

        <Form.Item name="keywords" label="郵件內文關鍵字" tooltip="輸入字串（可多筆），若郵件內容含任一關鍵字則會發報。">
          <Select mode="tags" placeholder="例如：漏水，異常，火警" />
        </Form.Item>

        <Form.Item
          name="send_all_to_customer"
          label="篩選結果全送客戶群"
          valuePropName="checked"
          tooltip="啟用後，不論篩選結果是否命中，圖片都會送至客戶群（TG + LINE）"
        >
          <Switch checkedChildren="啟用" unCheckedChildren="停用" />
        </Form.Item>

        {selectedGroup && (
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default GroupSettingModal;